import React from 'react';

const Switch = ({ 
  checked, 
  onChange, 
  disabled = false,
  label = '',
  id = ''
}) => {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      id={id}
      disabled={disabled}
      onClick={onChange}
      className={`relative inline-flex h-[23px] w-[40px] flex-shrink-0 items-center rounded-full transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:ring-offset-2 ${
        checked ? 'bg-emerald-400' : 'bg-gray-300'
      } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
    >
      <span
        className={`inline-block h-[17px] w-[17px] transform rounded-full bg-white shadow transition-transform duration-200 ease-in-out ${
          checked ? 'translate-x-[20px]' : 'translate-x-0.5'
        }`}
      />
    </button>
  );
};

export default Switch;

